import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from './../../services/auth.service';
import { Component, OnInit, Renderer2, ViewChild, ElementRef } from '@angular/core';
import { NgForm } from '../../../../node_modules/@angular/forms';

@Component({
  selector: 'app-recuperar-pyme',
  templateUrl: './recuperar-pyme.component.html',
  styleUrls: ['./recuperar-pyme.component.css']
})
export class RecuperarPymeComponent implements OnInit {

  @ViewChild("mensajeRecuperar2") mensajeRecuperar2: ElementRef;
  @ViewChild("formulario2") formulario2: ElementRef;

  password:string;
  email2:string;
  password2:string;
  primerIntento:boolean=true;
  tipo:string;
  cliente={};
  cliente2={};
  
  constructor(private auth:AuthService, private router:Router, private activatedRoute:ActivatedRoute,
    private renderer:Renderer2) { }

  ngOnInit() {
    if(this.auth.isAuthenticated()){
      
      this.router.navigate(['home']);
    }
  }

  guardarNuevaPassPymes(myform: NgForm){
    this.renderer.addClass(this.formulario2.nativeElement, "ng-submitted");
    
    if(myform.valid){
      
      this.auth.recuperarPassClientePymes(this.cliente2)
      .subscribe(resp=>{
        let texto=this.renderer.createText("");
                
        if(resp["err"]==false){
          texto=this.renderer.createText("Se le ha enviado su nueva contraseña al correo.");
          this.renderer.setStyle(this.mensajeRecuperar2.nativeElement,"color", "green");
        }else{
          texto=this.renderer.createText(resp["msg"]);
          this.renderer.setStyle(this.mensajeRecuperar2.nativeElement, "color", "red");
        }
        this.renderer.appendChild(this.mensajeRecuperar2.nativeElement, texto);
        setTimeout(() => {
          this.renderer.removeChild(this.mensajeRecuperar2.nativeElement, texto);
        }, 1500);

      });
      
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/recuperar-pyme/recuperar-pyme.component.ts